import { createBrowserRouter } from "react-router-dom";
import Home from "./Pages/Home";
import { isMobile } from "react-device-detect";
import MobileHome from "./Pages/Mobile/MobileHome";
import Comms from "./Pages/Comms";

export const router = isMobile ? createBrowserRouter([
    {
        path: "/",
        element: <MobileHome />
    },
    {
        path: "/commissions",
        element: <Comms />
    },
    {
        path: "/gallery",
        element: <div />
    }
]) : createBrowserRouter([
    {
        path: "/",
        element: <Home />
    },
    {
        path: "/commissions",
        element: <Comms />
    },
    {
        path: "/gallery",
        element: <div />
    }
])
